import { useOrganizationDetailsStore } from '@libs/store/settings';
import { useNotification } from '@libs/snackbar';
import { Box, InputAdornment, Stack, styled, Typography, useTheme } from '@mui/material';
import { SettingsPagePane } from '../../components';
import { Button } from '@atoms/buttons';
import { FaIcon } from '@atoms/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { DelayedLinearProgress } from '@molecules/feedback';
import { PrimaryPaper } from '@atoms/layout';
import { FacilityTypesFilters } from './filters';
import { FacilityTypesTable } from './table/table';
import { useEffect } from 'react';
import { useFacilityTypesListStore } from '@libs/store/facilityTypes/listStore';

export function FacilityTypesSettings() {
  const theme = useTheme();
  const { showError, showSuccessIntl } = useNotification();
  const { load, initialized, loadingList, facilityTypes } = useFacilityTypesListStore();

  const loading = loadingList;
  const localizationSubset = `settings.facilityTypes`;

  useEffect(() => {
    load();
  }, [load]);

  const handleAddButtonClick = () => {
    console.log('Add button clicked'); // Add button clicked
  };

  return (
    <SettingsPagePane>
      <DelayedLinearProgress show={loading} />
      <Box
        flex={1}
        flexGrow={1}
        flexDirection="column"
        sx={(theme) => ({ width: `100%`, height: `calc(100% - ${theme.spacing(6)})`, padding: theme.spacing(3) })}
      >
        {/* Header */}
        <Stack direction={'row'}>
          <Typography variant="h5">
            <FormattedMessage id={`${localizationSubset}.pageHeading`} />
          </Typography>
          <Box flex={1} />
          <Button
            variant="contained"
            disabled
            onClick={handleAddButtonClick}
            sx={{ maxHeight: '40px', minWidth: '160px' }}
          >
            <FaIcon name="plus" color={theme.palette.background.paper} />
            <Box sx={(theme) => ({ marginLeft: theme.spacing(2) })}>
              <FormattedMessage id={`${localizationSubset}.menu.addButton.label`} />
            </Box>
          </Button>
        </Stack>
        <PrimaryPaper sx={{ height: '100%', minHeight: 0, mt: 2 }}>
          <Stack direction={'column'} sx={{ height: '100%' }}>
            <FacilityTypesFilters loading={loading} localizationSubset={localizationSubset} />
            <Box mt={2} height="100%" minHeight={0}>
              <FacilityTypesTable loading={loading} rows={facilityTypes} localizationSubset={localizationSubset} />
            </Box>
          </Stack>
        </PrimaryPaper>
      </Box>
    </SettingsPagePane>
  );
}
